/**
 * Events emitted if the chapter player is used.
 *
 * @deprecated
 * This feature is deprecated and will be removed in version 2.x.
 * If you still need this feature, please implement it yourself.
 */
export const ChapterEvent = {
  /**
   * Chapters were parsed and created
   *
   * @privateRemarks
   * Since this is deprecated, we don't bother splitting this enum into public and internal.
   *
   * @internal
   */
  ChaptersCreated: 'chapterPlayer:ChaptersCreated',

  /**
   * A chapter was started
   */
  ChapterStarted: 'chapterPlayer:ChapterStarted',

  /**
   * A chapter was finished
   */
  ChapterEnded: 'chapterPlayer:ChapterEnded',

  /**
   * The last chapter finished.
   *
   * @remarks
   * You should listen to this event to know when the player has finished playing all chapters.
   * Once the player has finished all chapters you can continue with the next video.
   * Video in the sense of the next video in a playlist or the next episode of a series.
   */
  LastChapterEnded: 'chapterPlayer:LastChapterEnded',
} as const;

/**
 * {@inheritDoc ChapterEvent:var}
 */
export type ChapterEvent = (typeof ChapterEvent)[keyof typeof ChapterEvent];
